var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 18.6273 18.6273 24 12 24C5.37333 24 0 18.6273 0 12C0 5.37333 5.37333 0 12 0C18.6273 0 24 5.37333 24 12Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 13.3334C8.58714 13.3334 9.33333 12.2887 9.33333 11C9.33333 9.71136 8.58714 8.66669 7.66667 8.66669C6.74619 8.66669 6 9.71136 6 11C6 12.2887 6.74619 13.3334 7.66667 13.3334Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3332 13.3334C17.2536 13.3334 17.9998 12.2887 17.9998 11C17.9998 9.71136 17.2536 8.66669 16.3332 8.66669C15.4127 8.66669 14.6665 9.71136 14.6665 11C14.6665 12.2887 15.4127 13.3334 16.3332 13.3334Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6569 18.586C15.6496 18.5567 14.8936 15.6667 12.0002 15.6667C9.10691 15.6667 8.35091 18.5567 8.34358 18.586C8.30824 18.728 8.37291 18.8734 8.49824 18.9487C8.62358 19.0234 8.78691 19.006 8.89558 18.9087C8.90158 18.904 9.57091 18.3334 12.0002 18.3334C14.3936 18.3334 15.0782 18.8867 15.1042 18.9087C15.1676 18.9694 15.2502 19 15.3336 19C15.3896 19 15.4462 18.986 15.4976 18.9574C15.6282 18.8834 15.6936 18.7314 15.6569 18.586Z",
    fill: "#664500"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66667 20C6.66667 21.8413 5.17467 23.3333 3.33333 23.3333C1.492 23.3333 0 21.8413 0 20C0 18.1586 2.66667 13.3333 3.33333 13.3333C4 13.3333 6.66667 18.1586 6.66667 20Z",
    fill: "#5DADEC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0002 8.66664C16.2975 8.66664 14.7988 5.75531 14.7368 5.63131C14.5722 5.30198 14.7055 4.90131 15.0348 4.73664C15.3628 4.57198 15.7628 4.70464 15.9282 5.03198C15.9782 5.12931 17.1422 7.33331 20.0002 7.33331C20.3688 7.33331 20.6668 7.63198 20.6668 7.99998C20.6668 8.36864 20.3688 8.66664 20.0002 8.66664ZM4.00016 8.66664C3.63216 8.66664 3.3335 8.36798 3.3335 7.99998C3.3335 7.63198 3.63216 7.33331 4.00016 7.33331C7.38883 7.33331 7.9975 5.25331 8.02216 5.16464C8.11883 4.81264 8.48216 4.59931 8.83483 4.69198C9.18816 4.78464 9.40216 5.14064 9.3135 5.49531C9.28083 5.62464 8.4695 8.66664 4.00016 8.66664Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadEmoji);
export default __webpack_public_path__ + "static/media/sad-emoji.6f2df7f274586b32e1c116610370f2b1.svg";
export { ForwardRef as ReactComponent };